import React, { useState, useEffect } from 'react';
import ExportTable from '../Export';
import ResiliencyTable from './ResiliencyTable';
import { TableWrapper, StyledHeader, StyledTableWrapper } from './styled';
import { formatTableData } from './utils';

const ResiliencyTableWrapper = ({ data, interval }) => {
  const [filteredTableData, setFilteredTableData] = useState([]);

  useEffect(() => {
    if (data) {
      const formattedData = formatTableData(data);
      setFilteredTableData(formattedData);
    }
  }, [data]);

  return (
    <StyledTableWrapper>
      <StyledHeader>
        <h3>Impact Avoidance Events (Top 100)</h3>
        <ExportTable />
      </StyledHeader>
      <TableWrapper>
        <ResiliencyTable data={filteredTableData} interval={interval} />
      </TableWrapper>
    </StyledTableWrapper>
  );
};

export default ResiliencyTableWrapper;
